import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const customerRoutes: RouteRecordRaw[] = [
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/modules/customers/views/CustomerListView.vue'),
    meta: {
      permission: PERMISSIONS.ESHOP.CUSTOMERS,
      projectScoped: true,
    },
  },
  {
    path: '/customers/:id/detail',
    redirect: (to) => ({
      path: '/customers',
      query: { detail: to.params.id as string },
    }),
  },
  {
    path: '/customers/:id/edit',
    name: 'customer-edit',
    component: () => import('@/modules/customers/views/CustomerEditView.vue'),
    meta: {
      permission: PERMISSIONS.ESHOP.MANAGE,
      projectScoped: true,
    },
  },
]
